"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const index_1 = require("../../../highlight/index");
const useFormatNumberByNucleus_1 = require("../../../hooks/useFormatNumberByNucleus");
const styles = {
    container: {
        position: 'inherit',
        padding: '0.15rem 0.4rem',
    },
    errorLabel: {
        color: 'red',
    },
};
function AnalysisCell({ columnKey, value, activeTab }) {
    const highlight = (0, index_1.useHighlight)([columnKey]);
    const format = (0, useFormatNumberByNucleus_1.useFormatNumberByNucleus)(activeTab);
    return ((0, jsx_runtime_1.jsx)("div", { style: { ...styles.container, ...highlight.defaultActiveStyle }, ...highlight.onHover, children: value instanceof Error ? ((0, jsx_runtime_1.jsx)("span", { style: styles.errorLabel, children: value.message })) : (format(value)) }));
}
exports.default = AnalysisCell;
